export const thongTinVatHangHoa = {
  sections: {
    list: { title: 'Thông tin VAT hàng hóa' },
  },
  titles: {
    add: 'Thêm thông tin VAT',
    edit: 'Sửa thông tin VAT',
  },
  fields: {
    maSanPham: 'Mã sản phẩm',
    ghiChu: 'Note',
    ngayHachToan: 'Ngày hạch toán',
    dienGiai: 'Diễn giải',
    loaiTien: 'Loại tiền',
    tyGia: 'Tỷ giá',
    maHangKeToan: 'Mã hàng của kế toán',
    congTy: 'Công ty',
    tenHangKhaiVat: 'Tên hàng khai VAT',
    ghiChuMang: 'Note mảng',
    tkKho: 'TK kho',
    tkCongNo: 'TK công nợ/TK tiền',
    donViTinh: 'ĐVT',
    soLuong: 'Số lượng',
    donGia: 'Đơn giá',
    thanhTien: 'Thành tiền',
    donGiaVnd: 'Đơn giá VNĐ',
    phanTramThueGtgt: '% thuế GTGT',
    tienThueGtgt: 'Tiền thuế GTGT',
    tienThueGtgtQuyDoi: 'Tiền thuế GTGT quy đổi',
    tkDoiUngThueGtgt: 'TKĐƯ thuế GTGT',
    tkThueGtgt: 'TK thuế GTGT',
    nhomHhdvMuaVao: 'Nhóm HHDV mua vào',
    phiTruocHaiQuan: 'Phí trước hải quan',
    giaTinhThueNk: 'Giá tính thuế NK',
    phanTramThueNk: '% thuế NK',
    hangHoa: 'Hàng hóa trên hệ thống',
    ngayTao: 'Ngày tạo',
    ngayCapNhat: 'Ngày cập nhật',
  },
  filter: {
    searchPlaceholder: 'Tìm kiếm',
    textDetailTitle: 'Bộ lọc chi tiết',
    dateRangePlaceholder: 'Chọn khoảng ngày',
    fromDate: 'Từ ngày',
    toDate: 'Đến ngày',
    noOptions: 'Chưa có dữ liệu',
    lienKetAll: 'Tất cả',
    lienKetCo: 'Đã có trên hệ thống',
    lienKetKhong: 'Chưa có trên hệ thống',
  },
  filters: {
    hintSection: 'Tìm kiếm',
    hintBody:
      'Gõ mã sản phẩm, mã hàng của kế toán, tên hàng khai VAT, diễn giải hoặc công ty vào ô tìm kiếm phía trên.',
  },
  placeholders: {
    maSanPham: 'Tìm theo mã hoặc tên sản phẩm',
    noProduct: 'Không tìm thấy sản phẩm',
  },
  hints: {
    chuaLienKet: 'Chưa có trên hệ thống',
  },
  messages: {
    productTabEmpty: 'Chưa có thông tin VAT cho sản phẩm này.',
    loadError: 'Không tải được danh sách thông tin VAT.',
    noData: 'Chưa có thông tin VAT hàng hóa.',
    listSummary: 'Tổng {count} dòng',
    saveSuccess: 'Đã lưu thông tin VAT.',
    deleteSuccess: 'Đã xóa dòng thông tin VAT.',
    confirmDelete: 'Xóa dòng thông tin VAT của mã "{name}"?',
    selectedCount: 'Đã chọn {count}',
    deleteSelected: 'Xóa đã chọn ({count})',
    bulkDeleteConfirm: 'Xóa {count} dòng thông tin VAT đã chọn?',
    bulkDeleteSuccess: 'Đã xóa {count} dòng',
    bulkDeleteError: 'Xóa hàng loạt thất bại',
  },
  validation: {
    maSanPhamRequired: 'Vui lòng nhập mã sản phẩm.',
  },
  import: {
    description:
      'Tải file mẫu, điền theo đúng tiêu đề cột (dòng 1). Số hỗ trợ định dạng 4.216 / 0,16. Ngày hạch toán dạng dd/mm/yyyy, để trống hoặc 00/01/1900 nếu không có. Nếu file có dòng lỗi, hệ thống sẽ không nhập dòng nào.',
    cheDoNhap: 'Chế độ nhập',
    cheDoThemMoi: 'Thêm mới — giữ các dòng đã có',
    cheDoThayThe: 'Thay thế — xóa dòng cũ của các mã SP có trong file rồi nhập lại',
    success: 'Nhập thông tin VAT thành công.',
    failed: 'Nhập thông tin VAT thất bại.',
  },
}
